import { Button, Card } from 'nhsuk-react-components';
import ReviewerPicker from 'components/ReviewerPicker';
import { CognitoUser, UserInfo } from 'schemas/UserInfo.schema.ts';
import { useState } from 'react';

interface ISetSelectedSummaryReportReviewersProps {
  teamId: string;
  iterationCreator: UserInfo;
  onClickSubmit: (reviewers: CognitoUser[]) => Promise<void>,
}

function SetSelectedSummaryReportReviewers({
  teamId,
  iterationCreator,
  onClickSubmit,
}: ISetSelectedSummaryReportReviewersProps) {
  const [selectedReviewers, setSelectedReviewers] = useState<CognitoUser[]>([]);

  return (
    <>
      <Card>
        <ReviewerPicker
          selectedReviewers={selectedReviewers}
          setSelectedReviewers={setSelectedReviewers}
          content={(
            <>
              <h3 className="nhsuk-heading-s nhsuk-u-margin-bottom-3">
                Report reviewer(s)
              </h3>
              <p>
                These are the users who will be able to approve or reject the summary report.
              </p>
            </>
            )}
          teamId={teamId!}
          iterationCreator={iterationCreator}
        />
      </Card>
      <Button onClick={() => onClickSubmit(selectedReviewers)}>
        Set report reviewers
      </Button>
    </>
  );
}
export default SetSelectedSummaryReportReviewers;
